module.exports = "<div class=\"image-viewer\">\n  <img ng-src=\"{{ imgSrc }}\" />\n</div>\n"